<template>
  <v-card>
    <v-card-text>
  <v-form
     v-model="valid"
     ref="form"
  >
      <v-layout row wrap>
        <v-flex xs12>
          <v-select
            :items="layouts"
            v-bind:value="activePlaylist.events[index].layout_id"
            @change="updateEvent($event, index, 'layout_id')"
            item-text="name"
            item-value="id"
            label="Layout"
            outline
            single-line
            hide-details
          ></v-select>
        </v-flex>
        <v-flex
          xs6
        >
          <v-combobox
            v-mask="'##:##'"
            :value="activePlaylist.events[index].start_time"
            prepend-icon="timer"
            :items="times"
            label="Start time"
            @input="updateEvent($event, index, 'start_time')"
          ></v-combobox>
        </v-flex>
        <v-flex
          xs6
        >
          <v-combobox
            v-mask="'##:##'"
            :value="activePlaylist.events[index].end_time"
            prepend-icon="timer_off"
            :items="times"
            label="End time"
            :rules=rulesEndTime
            @input="updateEvent($event, index, 'end_time')"
            :disabled="!! parseInt(ourEvent.duration)"
          ></v-combobox>
        </v-flex>

        <v-flex xs6>
        </v-flex>

        <v-flex xs6>
          <v-text-field
            v-bind:value="activePlaylist.events[index].duration"
            @input="updateEvent($event, index, 'duration')"
            prepend-icon="mdi-timer-sand"
            label="Duration"
            :rules="rulesDuration"
            min="0"
            :disabled="(ourEvent.end_time != '') && (ourEvent.end_time !== null)"
          ></v-text-field>
        </v-flex>

        <v-flex xs6>
          <v-text-field
            v-bind:value="activePlaylist.events[index].repeat"
            @change="updateEvent($event, index, 'repeat')"
            prepend-icon="repeat"
            label="Repeat"
            :rules="rulesRepeat"
            min="0"
          ></v-text-field>
        </v-flex>

        <v-flex
          xs6
        >
          <v-checkbox
            label="Loop to start"
            :value="activePlaylist.events[index].loop_start"
            :input-value="activePlaylist.events[index].loop_start"
            :false-value="0"
            :true-value="1"
            @change="updateEvent($event, index, 'loop_start')"
          ></v-checkbox>
        </v-flex>
      </v-layout>
  </v-form>
    </v-card-text>
  </v-card>
</template>

<script>
import { mask } from 'vue-the-mask';

export default {
  directives: { mask },
  props: {
    index: {
      type: Number,
      required: true,
    },
    length: {
      type: Number,
      required: true,
    },
  },
  computed: {
    ourEvent: {
      get() {
        return this.activePlaylist.events[this.index];
      },
    },
    activePlaylist: {
      get() {
        return this.$store.getters.getActivePlaylist;
      },
    },
    layouts: {
      get() {
        return this.$store.getters.getLayouts;
      },
    },
  },
  watch: {
    valid(newVal, oldVal) { // eslint-disable-line no-unused-vars
      this.updateEvent(newVal, this.index, 'valid');
    },
  },
  data() {
    return {
      eventData: {},
      valid: false,
      rulesEndTime: [
        (v) => (!!(this.ourEvent.start_time) && !v && this.ourEvent.duration <= 0) && 'either end time or duration is required',
        // eslint-disable-next-line no-unused-vars
        (v) => (!!(this.ourEvent.start_time) && !!(this.ourEvent.end_time) && (this.timeToInt(this.ourEvent.start_time) >= this.timeToInt(this.ourEvent.end_time))) && 'start time needs to be less then end time',
      ],
      rulesDuration: [
        (v) => this.isNumberOrNull(v) || 'natural number is required',
        (v) => (!!(this.ourEvent.start_time) && (v === null || v <= 0) && (this.ourEvent.end_time === null || this.ourEvent.end_time.length === 0)) && 'either end time or duration is required',
      ],
      rulesRepeat: [
        (v) => this.isNumberOrNull(v) || 'natural number is required',
      ],
      times: [
        '00:00', '00:30',
        '01:00', '01:30',
        '02:00', '02:30',
        '03:00', '03:30',
        '04:00', '04:30',
        '05:00', '05:30',
        '06:00', '06:30',
        '07:00', '07:30',
        '08:00', '08:30',
        '09:00', '09:30',
        '10:00', '10:30',
        '11:00', '11:30',
        '12:00', '12:30',
        '13:00', '13:30',
        '14:00', '14:30',
        '15:00', '15:30',
        '16:00', '16:30',
        '17:00', '17:30',
        '18:00', '18:30',
        '19:00', '19:30',
        '20:00', '20:30',
        '21:00', '21:30',
        '22:00', '22:30',
        '23:00', '23:30',
      ],
    };
  },
  mounted() {
    this.revalidateAll();
  },
  methods: {
    revalidateAll() {
          this.$refs.form.validate();
    },
    isNumberOrNull(v) {
      if (!v || v === null) return true;
      if (
        v.length === 0 || (
          !Number.isNaN(v)
          && parseInt(v, 10) == v // eslint-disable-line eqeqeq
          && parseInt(v, 10) > 0
        )
      ) return true;
      return false;
    },
    timeToInt(v) {
      if (!v || !v.match(/^[012]?[0-9]:[012345]?[0-9]$/)) {
        return null;
      }
      const p = v.split(':');
      const res = 60 * parseInt(p[0], 10) + parseInt(p[1], 10);
      return res;
    },
    updateEvent(value, index, key) {
      // console.log("updateEvent "+index+" "+key+" "+value);
          switch (key) {
          case 'duration':
                // eslint-disable-next-line eqeqeq
                if (!(value == '' || value === null || parseInt(value, 10) > 0)) return false;
                break;
          default: // ignore
          }

      const payload = {
        data: [
          {
            index,
            key,
            value,
          },
        ],
      };

      this.$store.dispatch('UPDATE_EVENT', payload)
            .then(() => this.revalidateAll());
      return true;
    },
  },
};
</script>

<style scoped>

</style>
